import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MUIDataTable from 'mui-datatables';
import Popover from '@material-ui/core/Popover';
import TableCell from '@material-ui/core/TableCell';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import {
  Tooltip,
  CircularProgress,
  useTheme,
  Typography,
} from '@material-ui/core';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import KenButton from '../../../components/KenButton';
import SearchBox from '../../../components/SearchBox';
import FilterIcon from '../../../assets/icons/Filter.svg';
import lightTheme, {
  overridings as newTheme,
} from '../../../themes/light-theme';
import { useHistory } from 'react-router-dom';
import Popup from '../../Popup';
import ApplyFor from '../../ApplyFor';

const useStyles = makeStyles((theme) => ({
  //Filter Icon
  filterIcon: {
    height: '12px',
    width: '12px',
    margin: '3px 0px -3px 5px',
  },
  //Filter Dropdown
  root: {
    display: 'flex',
  },
  formControl: {
    margin: theme.spacing(3),
  },

  // Search
  SearchBoxContainer: {
    float: 'right',
    position: 'absolute',
    top: '13px',
    right: '14px',
    // width: '136px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  // Table
  tableCaption: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    color: theme.palette.KenColors.white,
  },
}));

const AcademicProgramsDataTable = (props) => {
  const classes = useStyles();
  const [tableData, setTableData] = useState([]);
  const [initialTableData, setInitialTableData] = useState([]);
  const [filterState, setFilterState] = useState({});
  const history = useHistory();
  const { loading } = props;
  const [currentRow, setCurrentRow] = useState({});

  const theme = useTheme();

  //For Modal Popup
  const [open, setOpen] = React.useState(false);

  const handleProgramSelection = (row) => {
    setOpen(true);

    setCurrentRow({
      programId: row.Id,
      AcademicYear: row.AcademicYear,
      CurrencyCodec: row.CurrencyCodec,
      CurrencySymbolc: row.CurrencySymbolc,
      internationalCurrencySymbolc: row.internationalCurrencySymbolc,
      internationalCurrencyCodec: row.internationalCurrencyCodec,
      ApplicableFees: row.ApplicableFees,
      instituteId: row.InstituteId,
      institute: row.Institute,
      department: row.Department,
      academicProgram: row.academicprogram,
      type: row.Type,
      startDate: row.StartDate,
      endDate: row.EndDate,
      fees: row.Fees,
      feeInRupees: row.Fees,
      internationalFees: row.internationalFees,
    });
  };

  const handleClose = (event, reason, submitted) => {
    if (['escapeKeyDown', 'backdropClick'].includes(reason)) return;
    setOpen(false);
  };

  const tableTheme = createMuiTheme({
    ...newTheme,
    overrides: {
      MuiTable: {
        root: {
          borderSpacing: '0px 5px',
          borderCollapse: 'separate',
        },
      },
      MuiToolbar: {
        root: {
          textAlign: 'left',
          backgroundColor: theme.palette.KenColors.primary,
        },
      },
      MUIDataTableHeadCell: {
        sortAction: {
          alignItems: 'center',
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontSize: '10px',
          lineHeight: '14px',
          color: theme.palette.KenColors.neutral400,
        },
        sortActive: {
          color: theme.palette.KenColors.neutral900,
        },
        root: {
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontSize: '10px',
          lineHeight: '14px',
          color: theme.palette.KenColors.neutral400,
        },
        fixedHeader: {
          backgroundColor: theme.palette.KenColors.neutralGray10,
          padding: '12px',
        },
      },
      MuiTableCell: {
        root: {
          borderBottom: 'none',
          padding: '2px 10px',
        },
        head: {
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontSize: '10px',
          lineHeight: '14px',
          color: theme.palette.KenColors.neutral400,
        },
        body: {
          maxWidth: '250px',
        },
      },
      MuiTablePagination: {
        toolbar: {
          backgroundColor: theme.palette.KenColors.neutralGray10,
          padding: 0,
        },
        input: {
          margin: 0,
        },
        root: {
          margin: 0,
        },
        actions: {
          margin: '0 !important',
        },
        input: {
          margin: 0,
        },
        root: {
          margin: 0,
        },
        actions: {
          margin: "0 !important",
        },

      },

      MuiPaper: {
        elevation4: {
          boxShadow: 'none',
        },
        rounded: {
          backgroundColor: theme.palette.KenColors.neutral20,
        },
      },
      MuiTableRow: {
        root: {
          backgroundColor: theme.palette.KenColors.white,
        },
        footer: {
          backgroundColor: theme.palette.KenColors.neutralGray10,
        },
      },
      MUIDataTableHeadRow: {
        root: {
          backgroundColor: theme.palette.KenColors.neutralGray10,
        },
      },
      MUIDataTableBodyRow: {
        stackedParent: {
          padding: '0px',
        },
      },
      MUIDataTableBodyCell: {
        root: {
          lineHeight: '20px',
          [theme.breakpoints.down('sm')]: {
            padding: 6,
          },
        },
        stackedCommon: {
          fontSize: '14px !important',
        },
      },
      MuiButton: {
        label: {
          color: theme.palette.KenColors.primary,
          // border: `1px solid ${theme.palette.KenColors.primary}`,
        },
      },
    },
  });
  useEffect(() => {
    setTableData(props.data);
    setInitialTableData(props.data);
  }, [props]);

  const columns = [
    {
      name: 'Id',
      label: 'ID',
      options: {
        display: false,
      },
    },
    {
      name: 'AcademicYear',
      label: 'AcademicYear',
      options: {
        display: false,
      },
    },
    {
      name: 'CurrencyCodec',
      label: 'CurrencyCodec',
      options: {
        display: false,
      },
    },
    {
      name: 'CurrencySymbolc',
      label: 'CurrencySymbolc',
      options: {
        display: false,
      },
    },
    {
      name: 'internationalCurrencySymbolc',
      label: 'internationalCurrencySymbolc',
      options: {
        display: false,
      },
    },
    {
      name: 'internationalCurrencyCodec',
      label: 'internationalCurrencyCodec',
      options: {
        display: false,
      },
    },
    {
      name: 'ApplicableFees',
      label: 'ApplicableFees',
      options: {
        display: false,
      },
    },
    {
      name: 'InstituteId',
      label: 'INSTITUTE ID',
      options: {
        display: false,
      },
    },
    {
      name: 'Institute',
      label: 'INSTITUTE',

      options: {
        filter: true,
        sort: true,
        display: false,
      },
    },
    {
      name: 'Department',
      label: 'DEPARTMENT',
      options: {
        filter: true,
        sort: true,
        customHeadRender: ({ index, ...column }) =>
          setCustomColumnHeader(index, column),
      },
    },
    {
      name: 'academicprogram',
      label: 'ACADEMIC PROGRAM',
      options: {
        filter: true,
        sort: true,
        customHeadRender: ({ index, ...column }) =>
          setCustomColumnHeader(index, column),
      },
    },
    {
      name: 'Type',
      label: 'TYPE',
      options: {
        filter: true,
        sort: true,
        display: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              <Typography style={{ fontSize: '12px', fontWeight: '400' }}>
                {value}
              </Typography>
            </div>
          );
        },
        customHeadRender: ({ index, ...column }) =>
          setCustomColumnHeader(index, column),
      },
    },
    {
      name: 'StartDate',
      label: 'START DATE',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'EndDate',
      label: 'END DATE',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'Fees',
      label: 'FEE (INDIAN)',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              <Typography style={{ fontSize: '12px', fontWeight: '400' }}>
                ₹ {value}
              </Typography>
            </div>
          );
        },
      },
    },
    {
      name: 'internationalFees',
      label: 'FEE (FOREIGN)',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              <Typography style={{ fontSize: '12px', fontWeight: '400' }}>
                {`${
                  tableMeta.rowData[6] === 'Both' ||
                  tableMeta.rowData[6] === 'Foreign'
                    ? tableMeta.rowData[4] || ''
                    : ''
                } ${
                  tableMeta.rowData[6] === 'Both' ||
                  tableMeta.rowData[6] === 'Foreign'
                    ? value || 'NA'
                    : 'NA'
                } `}
              </Typography>
            </div>
          );
        },
      },
    },
    {
      name: 'Apply',
      label: 'APPLY',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const rowIndex = tableMeta.rowIndex;
          const theCurrentRow = tableData && tableData[rowIndex];
          return (
            <div>
              <KenButton
                variant='secondary'
                onClick={() => {
                  handleProgramSelection(theCurrentRow);
                }}
              >
                Apply Now
              </KenButton>
            </div>
          );
        },
      },
    },
  ];

  const searchTableHandler = (event) => {
    let searchString = event.target.value;

    let columnsToFilter = [...initialTableData];
    let searchResult = columnsToFilter.filter((column) => {
      return (
        column.Institute.toLowerCase().includes(searchString.toLowerCase()) ||
        column.Department.toLowerCase().includes(searchString.toLowerCase()) ||
        column.academicprogram
          .toLowerCase()
          .includes(searchString.toLowerCase())
      );
    });

    setTableData(searchResult);
  };

  const title = (
    <Typography className={classes.tableCaption}>OPEN APPLICATIONS</Typography>
  );

  const muiDatatableOptions = {
    selectableRows: 'none',
    download: false,
    filter: false,
    print: false,
    viewColumns: false,
    rowsPerPage: 10,
    search: false,
    expandableRowsHeader: true,
    rowsPerPageOptions: [5, 10, 20, 30],
    customToolbar: () => {
      return (
        <div className={classes.SearchBoxContainer}>
          <SearchBox searchHandler={searchTableHandler} />
        </div>
      );
    },
    textLabels: {
      body: {
        noMatch: loading ? 'Fetching Data...' : 'No Matching Data',
        toolTip: 'Sort',
      },
    },
    sortOrder: {
      name: 'Institute',
      // direction: 'asc',
    },
  };

  const setCustomColumnHeader = (index, column) => {
    const columnFilterData = getColumnFilterData(column.name);
    return (
      <>
        <PopupState variant='popover' popupId='demo-popup-popover'>
          {(popupState) => (
            <>
              <TableCell
                key={index}
                {...bindTrigger(popupState)}
                style={{ minWidth: '160px' }}
              >
                <Tooltip title='Filter' style={{ cursor: 'pointer' }}>
                  <span>
                    {column.label}
                    <img className={classes.filterIcon} src={FilterIcon} />
                  </span>
                </Tooltip>
              </TableCell>

              <Popover
                {...bindPopover(popupState)}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
              >
                <div className={classes.root}>
                  <FormControl
                    component='fieldset'
                    className={classes.formControl}
                  >
                    <FormLabel component='legend'>{column.label}</FormLabel>
                    <FormGroup>
                      {columnFilterData.map((option, idx) => {
                        return (
                          <FormControlLabel
                            key={idx}
                            control={
                              <Checkbox
                                checked={
                                  (filterState[column.name] || {})[
                                    option.value
                                  ] || false
                                }
                                onChange={(event) =>
                                  columnFilterHandler(event, column.name)
                                }
                                name={option.value}
                                color='primary'
                              />
                            }
                            label={option.label}
                          />
                        );
                      })}
                    </FormGroup>
                  </FormControl>
                </div>
              </Popover>
            </>
          )}
        </PopupState>
      </>
    );
  };

  // get the column filter options
  const getColumnFilterData = (columnName) => {
    const columnFilterOptions = [];

    const uniqueOptions = new Map();

    initialTableData.map((data) => {
      if (!uniqueOptions.has(data[columnName])) {
        uniqueOptions.set(data[columnName], true);

        columnFilterOptions.push({
          label: data[columnName] || '',
          value: data[columnName] || '',
        });
      }
    });
    return columnFilterOptions;
  };

  // filter function for columns
  const columnFilterHandler = (event, columnName) => {
    // set filter state
    let columnState = { ...filterState[columnName] };
    columnState = { ...columnState, [event.target.name]: event.target.checked };
    setFilterState({ ...filterState, [columnName]: columnState });

    const searchStrings = Object.keys(columnState).filter(
      (k) => columnState[k] === true
    );

    if (searchStrings.length > 0) {
      const filterResult = initialTableData.filter((data) => {
        return searchStrings.indexOf(data[columnName] || '') !== -1;
      });

      // set table data
      setTableData(filterResult);
    } else {
      // set table data
      setTableData(initialTableData);
    }
  };

  // console.log(
  //   'props?.user?.userDetails',
  //   props?.user?.userDetails,
  //   'props.user',
  //   props.user,
  //   'history?.location?.state',
  //   history?.location?.state
  // );
  return (
    <div style={{ position: 'relative', marginTop: 20 }}>
      {loading && (
        <div
          style={{
            position: 'absolute',
            zIndex: 110,
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'rgba(255,255,255,0.8)',
          }}
        >
          <CircularProgress size={24} />
        </div>
      )}
      <Popup handleClose={handleClose} open={open}>
        <ApplyFor
          currentRow={currentRow}
          handleClose={handleClose}
          userData={
            props?.user?.userDetails || props.user || history?.location?.state
          }
        ></ApplyFor>
      </Popup>

      <MuiThemeProvider theme={tableTheme}>
        <MUIDataTable
          title={title}
          data={tableData}
          columns={columns}
          options={muiDatatableOptions}
        />
      </MuiThemeProvider>
    </div>
  );
};

export default AcademicProgramsDataTable;
